module.exports = __webpack_public_path__ + "img/sirui_offiaccount.1b67a094.png";